
/*
 * Le Clos — Wine Cellar
 * Quantity selector, AJAX cart, filters and sorting.
 * Compact cart button with loading spinner and success checkmark.
 */

(function () {
  "use strict";

  function rootUrl() {
    return (
      (window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root) ||
      "/"
    );
  }

  /* ---------- Styling ---------- */

  var style = document.createElement("style");

  style.textContent = `
    .leclos-wine-purchase {
      display: flex !important;
      align-items: center !important;
      justify-content: flex-start !important;
      flex-wrap: nowrap !important;
      gap: 10px !important;
      width: 100%;
      min-width: 0;
      box-sizing: border-box;
    }

    /* Quantity selector */

    .leclos-wine-quantity {
      display: flex !important;
      align-items: center !important;
      justify-content: space-between !important;
      flex: 0 0 132px !important;
      width: 132px !important;
      max-width: 132px !important;
      min-width: 0 !important;
      height: 42px !important;
      min-height: 42px !important;
      padding: 0 !important;
      margin: 0 !important;
      border: 1px solid #CEC8BE !important;
      border-radius: 8px !important;
      background: transparent !important;
      box-shadow: none !important;
      overflow: hidden;
      box-sizing: border-box;
    }

    .leclos-wine-qty-btn {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      flex: 0 0 38px !important;
      width: 38px !important;
      min-width: 38px !important;
      height: 100% !important;
      min-height: 0 !important;
      padding: 0 !important;
      margin: 0 !important;
      border: 0 !important;
      border-radius: 0 !important;
      background: transparent !important;
      color: #3A4937 !important;
      font-size: 19px !important;
      font-weight: 400;
      line-height: 1 !important;
      cursor: pointer;
      box-shadow: none !important;
      appearance: none;
      -webkit-appearance: none;
    }

    .leclos-wine-qty-btn:hover {
      background: rgba(58, 73, 55, 0.05) !important;
    }

    .leclos-wine-qty-btn:disabled {
      opacity: 0.35;
      cursor: not-allowed;
    }

    .leclos-wine-qty-input {
      display: block !important;
      flex: 1 1 auto !important;
      width: 54px !important;
      min-width: 0 !important;
      height: 100% !important;
      min-height: 0 !important;
      padding: 0 !important;
      margin: 0 !important;
      border: 0 !important;
      border-radius: 0 !important;
      background: transparent !important;
      color: #3A4937 !important;
      font-size: 15px !important;
      font-weight: 400;
      line-height: normal !important;
      text-align: center !important;
      box-shadow: none !important;
      outline: none !important;
      appearance: textfield !important;
      -webkit-appearance: none !important;
      -moz-appearance: textfield !important;
      box-sizing: border-box !important;
    }

    .leclos-wine-qty-input::-webkit-inner-spin-button,
    .leclos-wine-qty-input::-webkit-outer-spin-button {
      -webkit-appearance: none !important;
      margin: 0 !important;
    }

    /* Cart button */

    .leclos-wine-add {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      flex: 1 1 auto;
      width: auto !important;
      min-width: 0;
      height: 42px !important;
      min-height: 42px !important;
      margin: 0 !important;
      padding: 0 12px !important;
      border: 0 !important;
      border-radius: 8px !important;
      background: #3A4937 !important;
      color: #FAF5F0 !important;
      font-size: 12px !important;
      font-weight: 600;
      letter-spacing: 0.07em;
      cursor: pointer;
      text-align: center;
      box-shadow: none !important;
      box-sizing: border-box;
    }

    .leclos-wine-add:hover {
      background: #293728 !important;
    }

    .leclos-wine-add:disabled {
      opacity: 0.45;
      cursor: not-allowed;
    }

    .leclos-wine-add-icon {
      display: none;
      align-items: center;
      justify-content: center;
    }

    /* Loading spinner */

    .leclos-wine-add.is-loading .leclos-wine-add-icon svg {
      display: none !important;
    }

    .leclos-wine-add.is-loading .leclos-wine-add-icon::after {
      content: "";
      display: block;
      width: 19px;
      height: 19px;
      border: 2px solid rgba(250, 245, 240, 0.35);
      border-top-color: #FAF5F0;
      border-radius: 50%;
      animation: leclos-wine-spin 0.7s linear infinite;
      box-sizing: border-box;
    }

    /* Success checkmark */

    .leclos-wine-add.is-success .leclos-wine-add-icon svg {
      display: none !important;
    }

    .leclos-wine-add.is-success .leclos-wine-add-icon::after {
      content: "✓";
      display: block;
      font-size: 23px;
      font-weight: 400;
      line-height: 1;
      color: #FAF5F0;
    }

    /* Always use icon during loading and success */

    .leclos-wine-add.is-loading .leclos-wine-add-text,
    .leclos-wine-add.is-success .leclos-wine-add-text {
      display: none !important;
    }

    .leclos-wine-add.is-loading .leclos-wine-add-icon,
    .leclos-wine-add.is-success .leclos-wine-add-icon {
      display: flex !important;
    }

    @keyframes leclos-wine-spin {
      to {
        transform: rotate(360deg);
      }
    }

    /* Customer feedback */

    .leclos-wine-feedback {
      margin: 8px 0 0;
      color: #7A2E2E;
      font-size: 12px;
      line-height: 1.5;
    }

    .leclos-wine-feedback.is-success {
      color: #3A4937;
    }

    .leclos-wine-feedback[hidden] {
      display: none !important;
    }

    /* Desktop layout */

    @media screen and (min-width: 768px) {
      .wine-row__form {
        width: 100% !important;
        min-width: 0 !important;
        max-width: 100% !important;
        box-sizing: border-box !important;
      }

      .leclos-wine-purchase {
        gap: 8px !important;
      }

      .leclos-wine-quantity {
        flex: 0 0 110px !important;
        width: 110px !important;
        max-width: 110px !important;
        min-width: 110px !important;
        height: 40px !important;
        min-height: 40px !important;
      }

      .leclos-wine-qty-btn {
        flex: 0 0 30px !important;
        width: 30px !important;
        min-width: 30px !important;
        font-size: 16px !important;
      }

      .leclos-wine-qty-input {
        width: 40px !important;
        font-size: 14px !important;
      }

      .leclos-wine-add {
        flex: 0 0 46px !important;
        width: 46px !important;
        min-width: 46px !important;
        max-width: 46px !important;
        height: 40px !important;
        min-height: 40px !important;
        padding: 0 !important;
        overflow: hidden !important;
      }

      .leclos-wine-add-text {
        display: none !important;
      }

      .leclos-wine-add-icon {
        display: flex !important;
      }

      .leclos-wine-add:disabled:not(.is-loading):not(.is-success) .leclos-wine-add-text {
        display: block !important;
        font-size: 9px !important;
        line-height: 1.1 !important;
      }

      .leclos-wine-add:disabled:not(.is-loading):not(.is-success) .leclos-wine-add-icon {
        display: none !important;
      }
    }

    /* Mobile layout */

    @media screen and (max-width: 767px) {
      .wine-row__form {
        width: 100% !important;
        max-width: 100% !important;
        box-sizing: border-box;
      }

      .leclos-wine-purchase {
        gap: 12px !important;
      }

      .leclos-wine-quantity {
        flex: 0 0 132px !important;
        width: 132px !important;
        max-width: 132px !important;
        height: 44px !important;
        min-height: 44px !important;
      }

      .leclos-wine-add {
        height: 44px !important;
        min-height: 44px !important;
      }

      .leclos-wine-add-text {
        display: none !important;
      }

      .leclos-wine-add-icon {
        display: flex !important;
      }

      .leclos-wine-add:disabled:not(.is-loading):not(.is-success) .leclos-wine-add-text {
        display: inline !important;
      }

      .leclos-wine-add:disabled:not(.is-loading):not(.is-success) .leclos-wine-add-icon {
        display: none !important;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      .leclos-wine-add.is-loading .leclos-wine-add-icon::after {
        animation-duration: 2s;
      }
    }
  `;

  document.head.appendChild(style);

  /* ---------- Cart utilities ---------- */

  function updateCartCount(count) {
    var selectors =
      "[data-cart-count], .cart-count, " +
      ".cart_count, .cart-count-number, #cart-count";

    document.querySelectorAll(selectors).forEach(function (el) {
      el.textContent = count;
    });

    document.querySelectorAll('a[href$="/cart"]').forEach(function (link) {
      var target = null;

      link.querySelectorAll("*").forEach(function (node) {
        if (
          !node.children.length &&
          /^\s*\d+\s*$/.test(node.textContent)
        ) {
          target = node;
        }
      });

      if (!target && /^\s*\d+\s*$/.test(link.textContent)) {
        target = link;
      }

      if (target) {
        target.textContent = count;
      }
    });
  }

  var toastEl;
  var toastTimer;

  function showToast(message, showCartLink) {
    if (!toastEl) {
      toastEl = document.createElement("div");
      toastEl.className = "wine-toast";
      toastEl.setAttribute("role", "status");
      document.body.appendChild(toastEl);
    }

    toastEl.textContent = message;

    if (showCartLink) {
      var link = document.createElement("a");
      link.href = rootUrl() + "cart";
      link.textContent = "View cart";
      toastEl.appendChild(link);
    }

    toastEl.classList.add("is-visible");

    clearTimeout(toastTimer);

    toastTimer = setTimeout(function () {
      toastEl.classList.remove("is-visible");
    }, 4500);
  }

  function showFeedback(form, message, success) {
    var feedback = form.querySelector(".leclos-wine-feedback");

    if (!feedback) return;

    feedback.textContent = message;
    feedback.hidden = !message;
    feedback.classList.toggle("is-success", !!success);
  }

  function getQuantity(form) {
    var input = form.querySelector(".leclos-wine-qty-input");

    if (!input) return 1;

    var quantity = Number(input.value);

    if (
      !Number.isFinite(quantity) ||
      !Number.isInteger(quantity) ||
      quantity < 1
    ) {
      input.value = 1;
      return 1;
    }

    return quantity;
  }

  /* ---------- Quantity controls ---------- */

  document.addEventListener(
    "click",
    function (event) {
      var button = event.target.closest(
        "[data-wine-qty-minus], [data-wine-qty-plus]"
      );

      if (!button) return;

      var form = button.closest(".wine-row__form");

      if (!form) return;

      event.preventDefault();
      event.stopPropagation();

      var input = form.querySelector(".leclos-wine-qty-input");

      if (!input || input.disabled) return;

      var quantity = getQuantity(form);

      if (button.hasAttribute("data-wine-qty-plus")) {
        quantity += 1;
      } else {
        quantity = Math.max(1, quantity - 1);
      }

      input.value = quantity;
      showFeedback(form, "", false);
    },
    true
  );

  document.addEventListener("input", function (event) {
    if (event.target.matches(".leclos-wine-qty-input")) {
      var form = event.target.closest(".wine-row__form");

      if (form) {
        showFeedback(form, "", false);
      }
    }
  });

  document.addEventListener("change", function (event) {
    if (event.target.matches(".leclos-wine-qty-input")) {
      var form = event.target.closest(".wine-row__form");

      if (form) {
        getQuantity(form);
      }
    }
  });

  /* ---------- Add selected quantity to cart ---------- */

  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;

      if (!form.matches || !form.matches(".wine-row__form")) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      var button = form.querySelector(".leclos-wine-add");
      var idInput = form.querySelector('[name="id"]');

      if (!button || !idInput || button.disabled) {
        return;
      }

      var quantity = getQuantity(form);
      var variantId = Number(idInput.value);

      if (!variantId) {
        showFeedback(form, "Unable to identify this wine.", false);
        return;
      }

      showFeedback(form, "", false);

      button.disabled = true;
      button.setAttribute("aria-busy", "true");
      button.classList.remove("is-success");
      button.classList.add("is-loading");

      fetch(rootUrl() + "cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: quantity
            }
          ]
        })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return {
              ok: response.ok,
              status: response.status,
              data: data
            };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            var description =
              result.data &&
              (result.data.description || result.data.message);

            throw new Error(
              description || "The requested quantity is not available."
            );
          }

          button.classList.remove("is-loading");
          button.classList.add("is-success");

          showFeedback(
            form,
            quantity +
              (quantity === 1
                ? " bottle added to your cart."
                : " bottles added to your cart."),
            true
          );

          showToast(
            quantity +
              (quantity === 1
                ? " bottle added. "
                : " bottles added. "),
            true
          );

          return fetch(rootUrl() + "cart.js", {
            credentials: "same-origin",
            cache: "no-store",
            headers: {
              "Accept": "application/json"
            }
          })
            .then(function (response) {
              if (!response.ok) {
                throw new Error("Unable to refresh cart count.");
              }

              return response.json();
            })
            .then(function (cart) {
              updateCartCount(cart.item_count);
            });
        })
        .catch(function (error) {
          if (!button.classList.contains("is-success")) {
            showFeedback(
              form,
              error.message || "Unable to add this wine.",
              false
            );

            showToast(
              error.message || "Unable to add this wine.",
              false
            );
          }
        })
        .finally(function () {
          setTimeout(function () {
            button.disabled = false;
            button.removeAttribute("aria-busy");
            button.classList.remove("is-loading");
            button.classList.remove("is-success");
          }, 1500);
        });
    },
    true
  );

  /* ---------- Native Shopify filters ---------- */

  var root = document.querySelector("[data-wine-cellar]");

  if (!root) return;

  var filterForm = root.querySelector("[data-wine-filter-form]");
  var sortSelect = root.querySelector("[data-wine-sort]");
  var panel = root.querySelector("[data-wine-filters-panel]");
  var toggle = root.querySelector("[data-wine-filters-toggle]");
  var closeBtn = root.querySelector("[data-wine-filters-close]");

  function submitFilterForm() {
    if (filterForm) {
      filterForm.submit();
    }
  }

  if (filterForm) {
    filterForm.addEventListener("change", submitFilterForm);
  }

  if (sortSelect) {
    sortSelect.addEventListener("change", submitFilterForm);
  }

  /* ---------- Mobile filter drawer ---------- */

  function setOpen(open) {
    if (!panel || !toggle) return;

    panel.classList.toggle("is-open", open);
    toggle.setAttribute("aria-expanded", open ? "true" : "false");

    document.body.style.overflow = open ? "hidden" : "";
  }

  if (toggle) {
    toggle.addEventListener("click", function () {
      setOpen(true);
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      setOpen(false);
    });
  }

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      setOpen(false);
    }
  });
})();
